import React, { FC } from 'react';
import { PublicAuthView } from '../components';
import { useLocation } from 'react-router';

export const VerifyPage: FC = () => {
  const { search } = useLocation();

  return <PublicAuthView imageId={search} />;
};
